import React from 'react';
import { CellContext } from '@tanstack/table-core';

import { IPillProps, Pill } from '../../../../Pill';

export interface IPillCellProps {
    mapping?: Record<string | number, { color: IPillProps['color']; text?: string }>;
    cell: CellContext<any, string | number | null | undefined>;
}

export const PillCell = ({ cell, mapping }: IPillCellProps) => {
    const value = cell.getValue();
    const color = value ? mapping?.[value]?.color : undefined;
    const text = value ? mapping?.[value]?.text || value : '-';

    return <Pill color={color}>{text}</Pill>;
};
